import React from 'react';
import LoadState from 'src/components/LoadState/LoadState';
import ModernMessages from 'src/components/Messages/ModernizedMessages/ModernMessages';
import useSuiteMessagesOrchestrator, {
  UseSuiteMessagesOrchestratorReturn,
} from 'src/pages/Suite/useSuiteMessagesOrchestrator';

interface SuiteMessagesProps {
  suite: any;
  property: any;
  messages: any[];
  loadingMessages: boolean;
  isSending: boolean;
  postMessageToAPI: (data: any) => Promise<void>;
}

const SuiteMessages = ({
  suite,
  property,
  messages,
  loadingMessages,
  isSending,
  postMessageToAPI,
}: SuiteMessagesProps) => {
  const { user, onPostMessage }: UseSuiteMessagesOrchestratorReturn =
    useSuiteMessagesOrchestrator({
      suite,
      property,
      postMessageToAPI,
    });

  const isLoading: boolean = loadingMessages && messages.length === 0;

  return (
    <LoadState isLoading={isLoading}>
      <ModernMessages
        messages={messages}
        saving={isSending}
        offlineUser={{
          id: user.id,
          firstName: user.firstName || user.firstname || '',
          lastName: user.lastName || user.lastname || '',
          roles: user.roles,
        }}
        onPostMessage={onPostMessage}
      />
    </LoadState>
  );
};

export default SuiteMessages;
